// src/pages/admin/AdminVendorProductsWrapper.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import VendorProducts from "../vendor/VendorProducts";

export default function AdminVendorProductsWrapper() {
  const { vendorId } = useParams();
  const [vendorDoc, setVendorDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchVendor = async () => {
      try {
        if (!vendorId) {
          setError("Aucun identifiant vendeur fourni.");
          setLoading(false);
          return;
        }

        const ref = doc(db, "users", vendorId);
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          setError("Vendeur introuvable dans la collection users.");
        } else {
          setVendorDoc({ id: snap.id, ...snap.data() });
        }
      } catch (err) {
        console.error("Erreur chargement vendeur:", err);
        setError("Une erreur est survenue lors du chargement du vendeur.");
      } finally {
        setLoading(false);
      }
    };

    fetchVendor();
  }, [vendorId]);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 14,
          color: "#4b5563",
        }}
      >
        Chargement des informations du vendeur...
      </div>
    );
  }

  if (error || !vendorDoc) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 14,
          color: "#b91c1c",
        }}
      >
        {error || "Vendeur introuvable."}
      </div>
    );
  }

  const title =
    vendorDoc.shopName ||
    vendorDoc.displayName ||
    vendorDoc.email ||
    "Vendeur GoShop";

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f3f4f6",
        display: "flex",
        justifyContent: "center",
        padding: "24px 16px 40px",
      }}
    >
      <main
        style={{
          width: "100%",
          maxWidth: "1120px",
          fontSize: "14px",
          lineHeight: 1.5,
        }}
      >
        {/* En-tête admin contextuelle */}
        <header style={{ marginBottom: 16 }}>
          <h1
            style={{
              fontSize: 22,
              fontWeight: 800,
              color: "#0f172a",
              marginBottom: 4,
            }}
          >
            Produits de {title}
          </h1>
          <p
            style={{
              fontSize: 13,
              color: "#4b5563",
              marginBottom: 8,
            }}
          >
            Vous consultez la liste des produits créés par ce vendeur.
            Les validations / refus se gèrent dans votre interface
            <strong> AdminVendorProductsValidation</strong>.
          </p>
        </header>

        {/* Réutilisation de la même page produit, en mode admin */}
        <VendorProducts
          userDoc={vendorDoc}
          adminMode={true}
          adminVendorId={vendorId}
        />
      </main>
    </div>
  );
}
